import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { ENDPOINTS as GeneralEndpoints } from '../../../../General/Utils/Endpoints';
import { Models as GeneralModels } from '../../../../General/Utils/ModelsGeneral';
import AsignarCursosAreaModal from './AsignarCursosAreaModal';
import sigmaEdit from '../../../../Pages/img/Editar.png';

const PAGE_SIZE = 10;
const nombreTabla = "Asignación de Cursos por Área de Negocio";

export default function AsignarCursosAreaCatalog() {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]); // Áreas de Negocio
    const [query, setQuery] = useState('');
    const [page, setPage] = useState(1);

    const [modalOpen, setModalOpen] = useState(false);
    const [selectedArea, setSelectedArea] = useState(null);

    const loadData = async () => {
        setLoading(true);
        try {
            const res = await axios.get(GeneralEndpoints.areasNegocios);
            const data = (res.data || []).map(GeneralModels.areasNegocios);
            setRows(data);
        } catch (error) {
            console.error('Error al cargar áreas de negocio:', error);
            setRows([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    const filtered = useMemo(() => {
        let data = rows;
        if (query.trim()) {
            const q = query.toLowerCase().trim();
            data = data.filter((e) => e.nombre.toLowerCase().includes(q));
        }
        return data;
    }, [rows, query]);

    const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
    const paginated = useMemo(() => {
        const start = (page - 1) * PAGE_SIZE;
        return filtered.slice(start, start + PAGE_SIZE);
    }, [filtered, page]);

    useEffect(() => { if (page > totalPages) setPage(1); }, [totalPages, page]);

    const PageBtn = ({ label, onClick, active, disabled }) => (
        <button
            type="button"
            className={`roles-page-btn ${active ? 'is-active' : ''} ${disabled ? 'is-disabled' : ''}`}
            onClick={onClick}
            disabled={disabled}
        >
            {label}
        </button>
    );

    const pageNumbers = (() => {
        const maxToShow = 5;
        let start = Math.max(1, page - 2);
        let end = Math.min(totalPages, start + maxToShow - 1);
        start = Math.max(1, end - maxToShow + 1);
        return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    })();

    const startIndex = filtered.length === 0 ? 0 : (page - 1) * PAGE_SIZE + 1;
    const endIndex = Math.min(page * PAGE_SIZE, filtered.length);

    const handleOpenModal = (area) => {
        setSelectedArea(area);
        setModalOpen(true);
    };

    return (
        <>
            <div className="panel-sigma-main">
                <div className="roles-shell">
                    <div className="roles-topbar">
                        <h2 className="roles-title">{nombreTabla}</h2>
                        <input
                            className="roles-search"
                            placeholder="Buscar por nombre de área..."
                            value={query}
                            onChange={(e) => {
                                setQuery(e.target.value);
                                setPage(1);
                            }}
                        />
                    </div>

                    {loading ? (
                        <div className="catalog-loading">Cargando áreas de negocio...</div>
                    ) : (
                        <div className="roles-table-wrap">
                            <div className="roles-table-scroller">
                                <table className="roles-table">
                                    <thead>
                                        <tr>
                                            <th>Nombre del Área</th>
                                            <th style={{ textAlign: 'center' }}>Asignar Cursos</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {paginated.length === 0 ? (
                                            <tr>
                                                <td colSpan="2" style={{ textAlign: 'center' }}>
                                                    No se encontraron áreas de negocio.
                                                </td>
                                            </tr>
                                        ) : (
                                            paginated.map((area) => (
                                                <tr key={area.idAreaNegocio}>
                                                    <td>{area.nombre}</td>
                                                    <td style={{ textAlign: 'center' }}>
                                                        <button
                                                            type="button"
                                                            className="rk-iconbtn rk-iconbtn--edit"
                                                            onClick={() => handleOpenModal(area)}
                                                            title="Asignar Cursos"
                                                        >
                                                            <img src={sigmaEdit} alt="" className="rk-ico" />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                    <div className="roles-pagination">
                        <div className="roles-pagination-left">
                            {filtered.length > 0
                                ? <span>Mostrando {startIndex}–{endIndex} de {filtered.length}</span>
                                : <span>0 resultados</span>}
                        </div>
                        <div className="roles-pagination-right">
                            <PageBtn
                                label="‹"
                                onClick={() => setPage((p) => Math.max(1, p - 1))}
                                disabled={page === 1}
                            />
                            {pageNumbers.map((n) => (
                                <PageBtn
                                    key={n}
                                    label={n}
                                    onClick={() => setPage(n)}
                                    active={n === page}
                                />
                            ))}
                            <PageBtn
                                label="›"
                                onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                                disabled={page === totalPages}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {modalOpen && (
                <AsignarCursosAreaModal
                    open={modalOpen}
                    area={selectedArea}
                    onClose={() => setModalOpen(false)}
                />
            )}
        </>
    );
}
